import React,{Component} from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from "redux";

import * as adminCompaniesActions from "../../../actions/adminCompaniesActions";
import Spinner from "../../Shared/Spinner/index";
import Pager from '../../Shared/Pager'
import Filters from './Filters'
import {CookiesSettings} from '../../../helpers/cookiesHelper'
let cookiesSetting = new CookiesSettings("adminCompany")

let timer;

class Companies extends Component{
    constructor(props){
        super(props);

        let showFilters = cookiesSetting.get("showFilters");
        if(showFilters == undefined){
            showFilters = true
            cookiesSetting.set("showFilters",showFilters)
        }

        this.state={
            showFilters:showFilters
        }
        this.funcGetCompanies();
    }
    componentDidUpdate(){
        let {adminCompanies} = this.props;
        if(adminCompanies.needRefresh && !adminCompanies.fetching){
            this.funcGetCompanies()
        }
    }

    handleCountChange(e){
        let size = e.target.value;
        let {adminCompaniesActions} = this.props;
        adminCompaniesActions.ChangeCount(size);
    }
    handlePagerChange(pager) {
        let { adminCompaniesActions } = this.props;
        adminCompaniesActions.Change("page",pager.page);
        adminCompaniesActions.Change("needRefresh",true);
    }
    handleOnCompanyClick(e,id){
        this.props.history.push(`/admin/company/${id}`)
    }
    handleOnAddCompany(){
        this.props.history.push(`/admin/company/0`)
    }
    handleSearchOnChange(e){
        let { adminCompaniesActions } = this.props;

        let value = e.target.value;
        adminCompaniesActions.Change("name",value);

        clearTimeout(timer);

        timer =  setTimeout(()=>{

            adminCompaniesActions.Change("needRefresh",true);
        },600)
    }
    handleToggleFilters(){
        cookiesSetting.set("showFilters",!this.state.showFilters)
        this.setState({
            showFilters: !this.state.showFilters
        });
    }
    handleOnFiltersChange(filters){
        let {adminCompaniesActions} = this.props;

        adminCompaniesActions.Change("filters",filters);
        adminCompaniesActions.Change("page",1);
        adminCompaniesActions.Change("needRefresh",true);
    }
    handleFiltersReset() {
        let {adminCompaniesActions} = this.props;
        adminCompaniesActions.FiltersReset();
    }

    funcGetCompanies(){
        let {adminCompanies,adminCompaniesActions} = this.props;
        adminCompaniesActions.Get(
            (adminCompanies.page-1) * adminCompanies.size,
            adminCompanies.size,
            adminCompanies.name,
            adminCompanies.filters
        )
    }

    templateShown() {
        let { adminCompanies } = this.props;
        let from = ((adminCompanies.page - 1) * adminCompanies.size) + 1;
        let total = adminCompanies.total;
        let to = adminCompanies.page * adminCompanies.size;
        if (to > total) {
            to = total;
        }
        return <span>Показанно с {from} по {to} из {total }</span>;
    }

    render(){
        let {adminCompanies} = this.props;

        let className = "content admin-companies-page";
        if(adminCompanies.fetching){
            className += " fetching";
        }
        return(
            <div className={className}>
                {
                    adminCompanies.fetching ?
                        <Spinner
                            styles={{
                                backgroundColor: "#37474F"
                            }}
                            className="fixed-bottom"
                        />
                        : null
                }
                <div className="table-wrapp">

                    <div className="datatable-header">
                        <div className="controls ">
                            <div className="left-controls">
                                <div className="search">
                                    <div className="form-group has-feedback">
                                        <input type="text" className="form-control" value={adminCompanies.name} placeholder="Поиск по названию" onChange={(e) => this.handleSearchOnChange(e)}/>
                                        <div className="form-control-feedback">
                                            <i className="icon-search4 text-size-base"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="filter-bnt">
                                    <button type="button" className="btn btn-link" onClick={() => this.handleToggleFilters()}>
                                        Фильтр
                                        {
                                            this.state.showFilters ?
                                                <i className="fa fa-sort-up"></i>
                                                : <i className="fa fa-sort-down"></i>
                                        }

                                    </button>
                                </div>

                            </div>
                            <div className="right-controls">
                                <div className="count">
                                    <label>
                                        <span>Показывать:</span>
                                    </label>
                                    <select className="select form-control" value={adminCompanies.size} onChange={(e) => this.handleCountChange(e)}>
                                        <option value="15">15</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <button className="btn btn-success" onClick={()=>this.handleOnAddCompany()}>
                                    <i className="glyphicon glyphicon-plus"></i> Добавить компанию
                                </button>
                            </div>
                        </div>

                    </div>
                    {
                        this.state.showFilters ?
                            <Filters
                                data={adminCompanies.filters}
                                onFiltersChange={(filters) => this.handleOnFiltersChange(filters)}
                                onReset={() => this.handleFiltersReset()}
                            />
                            :null
                    }
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Название</th>
                                <th>Сайт</th>
                                <th>Статус</th>
                                <th>Шард</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                adminCompanies.data.length > 0 ?
                                    adminCompanies.data.map((item,index) => {
                                        let key = index
                                        return(
                                            <tr key={key} onClick={(e)=>this.handleOnCompanyClick(e,item.id)}>
                                                <td>{item.id}</td>
                                                <td>{item.name}</td>
                                                <td>{item.url}</td>
                                                <td>
                                                    {
                                                        item.isActive?
                                                            <span className="label label-success label-xs">активный</span>
                                                            :
                                                            <span className="label label-default">не активный</span>
                                                    }
                                                </td>
                                                <td>{item.shard}</td>

                                            </tr>
                                        )
                                    })
                                    : adminCompanies.set ?
                                    <tr>
                                        <td colSpan="4">
                                            Нет данных
                                        </td>
                                    </tr>
                                    :null
                            }
                            </tbody>
                        </table>
                    </div>
                    <div className="datatable-footer">
                        <div className="dataTables_info">
                            {this.templateShown()}
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_3_paginate">
                            <Pager
                                pager={{
                                    page: adminCompanies.page,
                                    count: adminCompanies.size,
                                    total: adminCompanies.total
                                }}
                                onPageChange={(pager) => this.handlePagerChange(pager)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        adminCompanies: state.adminCompanies
    }
}

function mapDispatchToProps(dispath) {
    return {
        adminCompaniesActions: bindActionCreators(adminCompaniesActions, dispath),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Companies);



// WEBPACK FOOTER //
// ./src/components/Admin/Companies/index.jsx